import { isEmpty } from 'lodash';

// Jest v30 does not allow us to mock or spy on window.location.
// These wrapper functions are a workaround to allow us to assert
// window.location.assign and window.location.reload are called
// correctly in tests.

export function navigateTo(url: string) {
  window.location.assign(url);
}

export function reloadPage() {
  window.location.reload();
}

/**
 * generates a unique id per interactionId and link, and optionally N sub links
 * e.g. getSideBarLinkId('1', ['Cover Sheet', 'Property Info']) => "1-Cover Sheet-Property Info"
 *
 * @param interactionId id of current interaction
 * @param linkNames array of strings (links->subLinks likely to be max depth)
 * @returns string that looks like`${interactionId-[LINK_NAME]-[SUB_LINK_NAME]}`
 */
export const getSideBarLinkId = (
  interactionId: string,
  linkNames: (string | undefined)[],
) => [interactionId, ...linkNames].filter((item) => !isEmpty(item)).join('-');
